import { useEffect, useState } from 'react';
import { getHandlePosition } from '@pages/schemes/utils';

// We need dynamically change position after rotation and Handle movement
// Depends on useRotation (rotation prop)

// Returns:
// - dynamicHandlePosition (new Flow Position for Handle, depends on rotation and initial HandlePosition)
// - setInitialHandlePosition (serves for modifying initial HandlePosition state after Handle movement)
const useDynamicHandlePosition = (rotation, data, handleId, defaultPositionState) => {
    const positionFromDataObject = data?.ports_positions?.[handleId]?.reactflow_position;
    const initialState = positionFromDataObject ?? defaultPositionState;
    const [initialHandlePosition, setInitialHandlePosition] = useState(initialState);
    const [dynamicHandlePosition, setDynamicHandlePosition] = useState(getHandlePosition(initialState, rotation));

    useEffect(() => {
        const newHandlePosition = getHandlePosition(initialHandlePosition, rotation);
        setDynamicHandlePosition(newHandlePosition);
        data.ports_positions &&
            data.ports_positions[handleId] &&
            (data.ports_positions[handleId].reactflow_position = initialHandlePosition);
    }, [initialHandlePosition, rotation]);

    return [dynamicHandlePosition, setInitialHandlePosition];
};

export default useDynamicHandlePosition;
